import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layer, useProjects } from "../../shared";
import RemotionPlayer from '../../remotion/RemotionPlayer';
import Page from '../templates/Page';
import { roundEven } from '../preview/Preview';

function Projects() {
  const navigate = useNavigate();
  const { projects } = useProjects(true);
  console.log({projects});
  const cols = 4;
  const w = roundEven(window.innerWidth / cols);
  return (
    <Page>
      <div style={{ 
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: cols * w
      }}>
        {projects.map((project, index) => {
          // resize dimensions to fit in window
          const h = roundEven(project.dimensions.height * w / project.dimensions.width);
          project.dimensions.width = w;
          project.dimensions.height = h;
          const resizedLayers: Layer[] = [];
          project.layers.forEach(layer => {
            if (resizedLayers.length > 10) return;
            const h = roundEven(layer.dimensions.height * w / layer.dimensions.width);
            resizedLayers.push({
              ...layer,
              dimensions: {
                width: w,
                height: h
              }
            })
          });
          project.layers = resizedLayers;
          return (
            <div
              key={index}  
              onClick={() => navigate(`/project/${project.projectId}`)}
              style={{ width: w, height: h }}>
              <RemotionPlayer project={project} />
            </div>
          )
        })}
      </div>
    </Page>
  );
}

export default Projects;
